import React, { useMemo } from 'react';
import Calendar from '../../../../../components/calendar/Calendar';
import useCalendar from '../../../../../customHooks/useCalendar';
import {
    CalendarEvent,
    CalendarView,
} from '../../../../../types/calendar/calendarTypes';
import { useBookingList } from '../../../../contextsProperty/ContextBookings';
import BookingEvent from './BookingEvent';
import { BookingListItem } from '../../../../../types/booking/bookingListTypes';
import { addOneDay } from '../../../../../utils/formatDates';

const BookingCalendar = () => {
    const { items, isLoading } = useBookingList();

    const {
        calendarRef,
        activeView,
        changeView,
        goToDate,
        prev,
        next,
        today,
        idHoveredEvent,
        hoverEvent,
        unhoverEvent,
    } = useCalendar({
        initialView: CalendarView.MONTH,
    });

    const events: CalendarEvent<BookingListItem>[] = useMemo(() => {
        return items.map(item => ({
            id: item.Id,
            title: item.BookingCode,
            start: item.CheckInDate,
            end: addOneDay(item.CheckOutDate),
            allDay: true,
            extendedProps: {
                ...item,
            },
        }));
    }, [items]);

    const renderEvent = (event: CalendarEvent<BookingListItem>) => {
        return (
            <BookingEvent
                event={event}
                idHoveredEvent={idHoveredEvent}
                hoverEvent={hoverEvent}
                unhoverEvent={unhoverEvent}
            />
        );
    };

    return (
        <div className='flex-grow overflow-y-auto'>
            <Calendar
                calendarRef={calendarRef}
                events={events}
                renderEvent={renderEvent}
                eventColor={'var(--background)'}
                isLoading={isLoading}
                onNext={next}
                onPrev={prev}
                onToday={today}
                onViewChange={changeView}
                onGoToDate={goToDate}
                activeView={activeView}
            />
        </div>
    );
};

export default BookingCalendar;
